import React from 'react';
import { Camera } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/content';
export function PostsGallerySection() {
  return <section className="bg-sand py-16 md:py-[84px]" data-id="element-191" data-mp="39w23tomgo0k8">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-192" data-mp="3evy9rtepy22f">
        <SectionHeading kicker="Mira los posts" icon={Camera} title={<>
              Tu Instagram, <em data-id="element-194" data-mp="2m7ixvfqvvzvb">resuelto por 30 días</em>
            </>} lead="Diseños listos para subir. Sin Canva, sin diseñador, sin perder horas." data-id="element-193" data-mp="2h98zyxdryl60" />
        <Reveal className="mt-9" data-id="element-195" data-mp="2vy55amog5k2x">
          <img src={images.postsGallery} alt="12 de los 30 posts incluidos en el kit" className="mx-auto block h-auto w-full max-w-[1080px] rounded-[14px]" width={1080} height={463} data-id="element-196" data-mp="2vydgma4x8hc0" />
        </Reveal>
        <div className="mt-10 text-center" data-id="element-197" data-mp="31ugmgwfj2tfc">
          <CtaButton data-id="element-198" data-mp="31t5ai9bxifd5">Quiero los 30 posts y todo el kit</CtaButton>
        </div>
      </div>
    </section>;
}